/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */
export enum Types {
  Initial = 'INITIALIZE',
  Login = 'LOGIN',
  Logout = 'LOGOUT',
  Register = 'REGISTER'
}

export type RowsState = {
  page: number;
  pageSize: number;
  loading: boolean;
};

export type TabType = {
  id: number | null;
  name: string;
  order: number;
  sub_headings?: any[] | null;
};

export type AdditionalInformationType = {
  activity?: any;
  annualRevenueCategory?: any;
  attentionCategory?: any;
  chainPosition?: any;
  clientType?: any;
  clientTypeExact?: any;
  creditworthiness?: any;
  decisionMotive?: any;
  erpId?: any;
  grossMarginCategory?: any;
  netRevenueCategory?: any;
  orientationChannel?: any;
  relationshipType?: any;
  sector?: any;
  standardInvoiceMethod?: any;
  standardPaymentCondition?: any;
  standardPaymentMethod?: any;
  vatCode?: any;
};

export type GeneralInformationType = {
  name?: string;
  websiteAddress?: string;
  type?: any;
  language?: any;
  email?: string;
  telephone?: string;
  mobileNumber?: string;
  whatsappNumber?: string;
  videoCallAddress?: string;
  otherNetwork?: string;
  erpId?: string;
  clientTypeExact?: any;
};

export type SubHeading = {
  id: number;
  name: string;
  fields: any[];
  order: number;
};

export type ContactInfo = {
  id?: number;
  name?: string;
  function?: string;
  email?: string;
  phone?: string;
  is_main_contact?: boolean;
};

export type Phase = {
  id?: number;
  name: string;
  color: string;
  total_stages?: number;
  total_projects?: number;
  description: string;
  order: number;
  created_at?: Date;
  updated_at?: Date;
};

export type Stage = {
  total_steps?: any;
  id: number;
  name: string;
  total_projects?: number;
  description: string;
  order?: number;
  phase?: Phase;
};

export type StaffMember = {
  id?: number;
  name?: string;
};

export type StageWorkplan = {
  description: string;
  id: number;
  name: string;
  order: number;
  phase: Phase;
};

export type PhaseWorkplan = {
  id: number;
  name: string;
  color: string;
};

export type Task = {
  id?: number;
  name: string;
  reporter: User;
  assignee: User;
  title?: string;
  description: string;
  project: Project;
  step?: Step;
  created_at?: Date;
  updated_at?: Date;
  deadline: Date;
  important: boolean;
  status: 'TO_DO' | 'DONE';
};

export type Step = {
  id: number;
  template: {
    id: number;
    name: string;
    stage: number;
    order: number;
    color: string;
  };
  stage?: number;
  name?: string;
  status: string;
  order: number;
};

export type StepInstance = {
  color: string;
  id: number;
  name: string;
  order: number;
  description: string;
  city: string;
  stage: number;
  status: string;
};

export type Project = {
  city: string;
  id: number;
  name: string;
  start_date: Date;
  expected_end_date: Date;
  location: string;
  current_step: {
    id: number;
    template: {
      id: number;
      name: string;
      description: string;
      stage: number;
      order: number;
      color: string;
    };
    status: string;
    order: number;
  };
  client: {
    id: number;
    name: string;
  };
  team: {
    id: number;
    leader: {
      id: number;
      organization_user: {
        id: number;
        name: string;
        email: string;
        role: string;
      };
      role: string;
    };
  };
  extra_fields: string;
  created_at: Date;
  updated_at: Date;
  created_by: {
    id: number;
    name: string;
    email: string;
    role: string;
  };
  updated_by: {
    id: number;
    name: string;
    email: string;
    role: string;
  };
  standard_files?: string[] | number[];
};

export type Workplan = {
  id?: number;
  title?: string;
  description: string;
  color?: string;
  project: number;
  start_at: Date;
  end_at: Date;
  department: number;
  assignees: number[];
  reporter: number[];
  icon?: number;
  tags: number[];
  stage: number;
  resourceId?: number;
};

export type Form = {
  id?: number;
  name: string;
  description?: string;
  step_templte: number;
  form_field: {
    field: number;
    required?: boolean;
  };
};

export type FormField = {
  id?: number;
  name: string;
  description?: string;
  step_templte: number;
  form_field: {
    field: number;
    required?: boolean;
  };
};

export type Components = {
  id?: number;
  component_type?: string;
  name?: string;
  description?: string;
};

export type Country = {
  name: string;
  code: string;
};

export type User = {
  id?: number;
  email: string;
  first_name?: string;
  last_name?: string;
  name?: string;
  user_id?: number;
  role?: string;
  pk?: number;
  organization?: any;
};

export type Staff = {
  id: number;
  email?: string;
  name: string;
  deaprtments?: Departments;
  preferred_language?: string;
  project_teams?: [];
  role?: string;
};

export type Note = {
  id?: number;
  name: string;
  created_by?: User;
  title?: string;
  description: string;
  project: Project;
  step?: Step;
  created_at?: Date;
  updated_at?: Date;
  important: boolean;
  status: 'OPEN' | 'CLOSED';
  communication_method: string;
  assignees: User[];
};

export type Appointment = {
  id?: number;
  name: string;
  created_by?: User;
  updated_by?: User;
  title?: string;
  description: string;
  project: Project;
  step?: Step;
  scheduled_for: Date;
  important: boolean;
  status: 'PENDING' | 'CONFIRMED' | 'CANCELED';
  communication_method: string;
  assignees: User[];
};

export type Incidence = {
  id?: number;
  name: string;
  created_by?: User;
  updated_at?: Date;
  created_at?: Date;
  title: string;
  indication: string;
  reasoning: string;
  is_reported_by_client: boolean;
  main_cause: string;
  reported_by?: User;
  contact_person: any;
  description: string;
  employee: User;
  generated_project: Project;
  mother_project: Project;
  status: 'TODO' | 'IN_PROGRESS' | 'DONE';
  accepted_date: Date;
  important: boolean;
  additional_cause: string;
  solved_at: Date;
  actions_to_solve: string;
};

export type MeetingMinutes = {
  id?: number;
  title: string;
  note?: string;
  meeting_type: string;
  frequency: string;
  meeting_date: Date;
  location: string;
  started_at?: string;
  ended_at?: string;
  projects: Project[];
  required_attendees: User[];
  optional_attendees?: User[];
  absentees?: User[];
  chair_person: User;
  secretary: User;
};

export type Departments = {
  id?: number;
  name: string;
  description: string;
  lead?: number;
  managers?: number[];
  members?: number[];
  organization: number;
};
export type Member = {
  id: number;
  email: string;
  name: string;
  role: string;
  disabled?: boolean;
};

export type Fields = {
  id: number;
  name: string;
  description: string;
  label: string;
  help_text: string;
  placeholder: string;
  value: string;
  source: string;
  internal_type: string;
};

export interface StepTemplateComponent {
  component: number;
}

export interface StepTemplate {
  id: number;
  name: string;
  stage: number;
  order: number;
  color: string;
  step_template_components: StepTemplateComponent[];
}

export interface Filter {
  operation: string;
  fieldname: string;
  lookup: string;
  value: string;
}

export interface Notification {
  action: string;
  action_target_field: string;
  actor: Member;
  created_at: Date;
  id: number;
  read_timestamp: Date;
  recipient_relation_with_target: string;
  target_object_id: number;
  target_object_name: string;
  target_object_type: string;
}

export interface PlanboardFilters {
  color?: string;
  project__id?: string;
  task__project__id?: string;
  id?: string;
  assignees__id?: string;
  task__assignee__id?: string;
  icon__id?: string;
  tags__id?: string;
  task__status?: string;
  task__important?: string;
  task__step__template__stage__id?: string;
}

export interface Resource {
  id: number | string;
  name?: string;
  title?: string;
  color?: string;
}
export type Resources = Resource[];

export interface TransformedResource {
  id: number | string;
  title: string;
}
export type TransformedResources = TransformedResource[];

export interface Event {
  id: number | string;
  title: string;
  assignees: User[];
  start_at: string;
  end_at: string;
  color: string;
  description: string;
  tags: [
    {
      id?: number;
      title?: string;
    }
  ];
  stage: {
    id: number | string;
    name: string;
  };
  task?: {
    assignee: any;
    reporter: any;
    title?: string;
    project: {
      id: number;
    };
    step: {
      stage: number;
    };
  };
  duration: string;
  hour: string;
  icon: any;
  project: {
    id: number | string;
    name?: string;
  };
}

export type Events = Event[];

export interface Holiday {
  date: string;
  localName: string;
  name: string;
  countryCode: string;
  fixed: boolean;
  global: boolean;
}

export type Holidays = Holiday[];

export interface TransformedEvent {
  id: string | number;
  title: string;
  start: string;
  end: string;
  color: string;
  description: string;
  resourceId: string | number;
  resourceIds?: string[] | number[];
  duration: string;
  hour: string;
  classNames?: string[];
  extendedProps: {
    project: string | number;
    icon: string;
    stageName: string;
  };
}

export type TransformedEvents = TransformedEvent[];

export type ProjectPermission = {
  id: number;
  content_type:
    | {
        id: number;
        model: string;
      }
    | number;
  object_id: number;
  role: string;
  permission: string;
};

export type DepartmentPermission = {
  id: number;
  content_type:
    | {
        id: number;
        model: string;
      }
    | number;
  department:
    | {
        id: number;
        name: string;
      }
    | number;
  object_id: number;
  role: string;
  permission: string;
};

export type ClientData = {
  name: string;
  mobile_number: string;
  website: string;
  vat_number: string;
  coc_number: string;
  iban: string;
  eori_number: string;
  g_account: string;
  currency: string;
  sector: string;
  standard_invoice_method: string;
  standard_payment_condition: string;
  relationship_type: string;
  email: string;
  telephone_number: string;
  visiting_address: {
    address_line: string;
    postal_code: string;
    country: string;
    city: string;
    region: string;
  };
  postal_address: {
    address_line: string;
    postal_code: string;
    country: string;
    city: string;
    region: string;
  };
  contacts: [
    {
      name: string;
      email: string;
      phone_number: string;
      function: string;
      is_main_contact: true;
    }
  ];
  additional_details: [];
};

export type UserPermission = {
  id: number;
  content_type:
    | {
        id: number;
        model: string;
      }
    | number;
  object_id: number;
  organization_user:
    | {
        id: number;
        name: string;
        email: string;
        role: string;
      }
    | number;
  permission: string;
};
